import { msiRequest } from "../../../index";
import { ResultType } from "../../../types";
import qs from "qs";
//接口url枚举
enum StatisticalEnumApi {
  WareToolReturn_PAGE = "/WareToolReturn/page", //分页查询工量具归还
  WareToolReturn_BORROW = "/WareToolReturn/returnTool" //原件归还
}
//工量具归还 --- 列表
export function WareToolReturnPage(data: any = {}) {
  return msiRequest.get<ResultType<any>>({
    url: `${StatisticalEnumApi.WareToolReturn_PAGE}?${qs.stringify(data)}`,
    data
  });
}

//工量具归还 -- 归还
export function returnWareToolReturn(data: any) {
  return msiRequest.post<ResultType<any>>({
    url: StatisticalEnumApi.WareToolReturn_BORROW,
    data
  });
}
